import React,{useEffect} from 'react';
import {exportPdf} from '../../function_lib/common_lib';

export function Comp_View_Cert_Port_Watches(props){
  //alert(JSON.stringify(props.editUser));
   useEffect(()=>{

   },[props.editUser]);
  
    return(<div className="modal fade bd-example-modal-xl"  id="divCertPortWatches" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Port Watchekeeping Records</h5>
          <a href={"javascript:void(0)"} onClick={()=>exportPdf("Port Watchkeeping Certificate","ptr_prtwatc_keeping_cert")} className="btn btn-sm btn-danger float-right">Pdf/Print</a>
          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        
       
        <div id="ptr_prtwatc_keeping_cert" className="modal-body">
             {/* form content  */}
             <div class="watchkeeping-certificate">
        <div class="header-container">
            <div class="header-box">Section 9.7- Port Watchkeeping Certificate</div>
            <div class="header-box">To be issued by the Master on every<br/>
            ship that the Cadet serves on</div>
        </div>
        
        <div class="logo-container">
            <img src="/logo.png" alt="GlobalMET Logo" class="main-logo"/>
            <img src="/dg_shipping_logo.png" alt="General Logo" class="logo"/>
            {/* <img src="/umulogo.png" alt="Maritime Logo" class="logo"/> */}
        </div>
        
        <div class="certificate-title">Port Watchkeeping Certificate</div>
        
        <div class="cadet-info">
            Name of Cadet: _______________________________<br/>
            Date of birth: _______________________________<br/>
            Passport number: _____________________________<br/>
            CDC No. :___________________________<br/>
            INDOS No.:_____________________________<br/>
        </div>
        
        <div class="headingg">This is to certify that the above named Cadet has served on board the ship</div>
        
        <div class="ship-period-line">
            <span></span> from <span></span> to <span></span>.
        </div>
        
        <div class="description">
        During this period of structured shipboard training, the Cadet has been assisting the deck officers in port Watchkeeping duties in
        accordance with STCW 2010 Table A-llll. 
        </div>
        
        <div  class="headingg">The number of port watches kept is as follows: </div>
        
        <div class="table-container">
            <table class="table">
                <tr>
                    <th>Port watches </th>
                    <th>Total number of watches </th>
                    <th>Total Hours </th>
                </tr>
                <tr>
                    <td>At Anchor </td>
                    <td></td>
                    <td></td>
                    
                </tr>
                <tr>
                    <td>Alongside</td>
                    <td></td>
                    <td></td>
                   
                </tr>
            </table>
            <div>
                <div class="signature-container">Master’s signature & ship’s stamp</div>
                <div class="signature-details">
                    <p>Master's Name: __________________________</p>
                    <p>Date: _____________</p>
                </div>
            </div>
        </div>
    
      </div>

             {/* end of form contacnt */}
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" data-dismiss="modal">Close</button>
          <button type="button" className="btn _btnSetColor111 btn-primary">Save</button>
        </div>
        
      </div>
      </div>
      </div>)
}

export default Comp_View_Cert_Port_Watches;